import {
  OtherSettingsInterface,
  TemplateSelectType,
} from "../../../../types/global.types";
import "./PreSelect.scss";
import { useRef } from "react";

interface PreSelectProps {
  onClick?: (
    e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => void;
  offerId: string;
  buttonFontWeight?: number;
  buttonFontSize?: string;
  showCheckboxSelect?: boolean;
  borderColor?: string;
  highlightColor?: string;
  checked: boolean;
  selectedButtonText?: string;
  notSelectedButtonText?: string;
  textColor?: string;
  buttonFontWeightSelect?: number;
  settings?: OtherSettingsInterface;
}

const PreSelect = ({
  onClick,
  offerId,
  buttonFontWeight,
  buttonFontSize,
  showCheckboxSelect,
  borderColor,
  highlightColor,
  checked,
  selectedButtonText,
  notSelectedButtonText,
  textColor,
  buttonFontWeightSelect,
  settings,
}: PreSelectProps) => {
  const labelRef = useRef<HTMLLabelElement>(null);

  return (
    <div
      className="pre-select"
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-label={checked ? `Unselect offer` : `Select offer`}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.stopPropagation();
          e.preventDefault();
          onClick?.(e);
          labelRef.current?.click();
        }
      }}
    >
      <div className="switch-wrapper">
        <label ref={labelRef} htmlFor={offerId}>
          {settings?.selectType === TemplateSelectType.checkbox && (
            <div className="select">
              <div
                style={{
                  borderColor: checked
                    ? settings?.activeBorderColor || highlightColor || "#3ab78f"
                    : settings?.borderColor || borderColor || "#d7d7d7",
                  backgroundColor: checked
                    ? settings?.activeBackgroundColor ||
                      highlightColor ||
                      "#3ab78f"
                    : "#ffffff33",
                }}
                className="checkbox"
              >
                {checked && (
                  <svg
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 1L4 8L1 5"
                      stroke="white"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            </div>
          )}

          {(settings?.selectType === TemplateSelectType.switch ||
            !settings?.selectType) && (
            <span
              className={
                checked
                  ? "switch-toggle switch-toggle--selected"
                  : "switch-toggle"
              }
              style={{
                backgroundColor: checked
                  ? settings?.activeBackgroundColor ||
                    highlightColor ||
                    "#3ab78f"
                  : settings?.backgroundColor || "#f1f2f3",
              }}
            >
              <span
                className={
                  checked
                    ? "switch-toggle-before switch-toggle-before--selected"
                    : "switch-toggle-before"
                }
                style={{
                  backgroundColor: checked
                    ? settings?.activeBorderColor || "#ffffff"
                    : settings?.borderColor || "#d7d7d7",
                }}
              ></span>
            </span>
          )}
          {settings?.selectType !== TemplateSelectType.button && (
            <span
              className="switch-text"
              style={{
                fontWeight: settings?.fontWeight || buttonFontWeightSelect || 0,
                fontSize: `${settings?.fontSize || buttonFontSize || 14}px`,
                color: checked
                  ? settings?.activeTextColor || textColor || "#000000"
                  : settings?.textColor || textColor || "#000000",
              }}
            >
              {checked
                ? selectedButtonText
                  ? selectedButtonText
                  : "Selected"
                : notSelectedButtonText
                ? notSelectedButtonText
                : "Select"}
            </span>
          )}

          {settings?.selectType === TemplateSelectType.button && (
            <div
              className={`switch-button  ${
                checked ? "switch-button--checked" : ""
              }`}
              style={{
                backgroundColor: checked
                  ? settings?.activeBackgroundColor || "#3ab78f"
                  : settings?.backgroundColor || "#f1f2f3",
                borderColor: checked
                  ? settings?.activeBorderColor || "#3ab78f"
                  : settings?.borderColor || "#c6c6c6",
                borderRadius:
                  typeof settings?.borderRadius === "number"
                    ? settings?.borderRadius
                    : 4,
              }}
            >
              <span
                className="switch-text"
                style={{
                  color: checked
                    ? settings?.activeTextColor || "#ffffff"
                    : settings?.textColor || "#000000",
                  fontWeight: settings?.fontWeight || 0,
                  fontSize: `${settings?.fontSize || 14}px`,
                }}
              >
                {checked && (
                  <svg
                    width={Number(settings?.fontSize) - 4 || 10}
                    height={Number(settings?.fontSize) - 6 || 8}
                    viewBox="0 0 10 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.84314 1.15494C9.01551 1.33394 9.01551 1.62415 8.84314 1.80315L3.98797 6.84506C3.8156 7.02406 3.53613 7.02406 3.36376 6.84506L1.15686 4.55329C0.984496 4.37429 0.984496 4.08407 1.15686 3.90507C1.32923 3.72607 1.6087 3.72607 1.78107 3.90507L3.67586 5.87274L8.21893 1.15494C8.3913 0.975941 8.67077 0.975941 8.84314 1.15494Z"
                      fill={settings?.activeTextColor || "#ffffff"}
                      stroke={settings?.activeTextColor || "#ffffff"}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}

                {checked
                  ? selectedButtonText
                    ? selectedButtonText
                    : "Selected"
                  : notSelectedButtonText
                  ? notSelectedButtonText
                  : "Select"}
              </span>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};

export default PreSelect;
